import Vue from 'vue'

import {mixin} from 'vue-chartjs'

import CChart from './../cchart/CChart';
import DiffChart from './../cchart/Template/DiffChart';

export default Vue.component('diff-chart', {
    template: '<canvas></canvas>',
    props: ['config', 'data','callback'],
    mounted: function () {
        let records = [];

        let maps = [];
        this.config['columns'].forEach((data) => {
            maps.push(data['label']);
        });

        //max scale
        let height=0;
        let max=0;
        this.data.forEach(function (data) {
            let items = [];
            maps.forEach((item) => {
                items.push(data[item]);
            });

            if(max<data['contains']){
                max=data['contains'];
            }
            height+=30;
            records.push({
                label: data['name'],
                all: data['total'],
                contains: data['contains'],
                items: items,
                shop: data['shop_id'],
                category: data['category'],
                brand: data['brand']
            });
        });

        height+=60;
        this.$el.height=height;
        let cchart = new CChart(this.$el, new DiffChart());
        this.config['max']=max;
        cchart.setConfig(this.config);

        cchart.setData(records);
        cchart.render();
    },
});



// WEBPACK FOOTER //
// ./src/components/offerAnalysis/DiffChart.js